import { useMutation, useQueryClient } from 'react-query'
import { postJSON } from 'common/services/api'
import dayjs from 'dayjs'
import { DISPOSAL_URL, STOCK_LOGS_QUERY_KEY } from './queryConstants'
import { DisposalData } from '../modalsV2/DisposalModal'

type UseDisposalProps = {
  residentId: string
  residentMedicationId: string
  onSuccess?: () => void
  onError?: (error: any) => void
}

type DisposalRequest = {
  residentId: string
  residentMedicationId: string
  date: string
  quantity: number
  witnessIds: string[]
  notes: string
  disposalMethod: string
  mediaAttachments: any[]
}

export const useDisposal = ({
  residentId,
  residentMedicationId,
  onSuccess,
  onError
}: UseDisposalProps) => {
  const queryClient = useQueryClient()

  const mutation = useMutation(
    (data: DisposalData) => {
      const actionedDateISO = data.actionedDate
        ? dayjs(data.actionedDate, 'DD-MM-YYYY').toISOString()
        : new Date().toISOString()

      const requestBody: DisposalRequest = {
        residentId,
        residentMedicationId,
        date: actionedDateISO,
        quantity: data.disposedStock,
        witnessIds: [], // Empty for now, can be added if witness functionality is needed
        notes: data.description,
        disposalMethod: data.disposalMethod,
        mediaAttachments: [] // Empty for now - file uploads would need separate handling
      }

      return postJSON({
        url: DISPOSAL_URL,
        json: requestBody
      })
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries([STOCK_LOGS_QUERY_KEY])
        onSuccess?.()
      },
      onError: (error) => {
        console.error('Error saving disposal:', error)
        onError?.(error)
      }
    }
  )

  return {
    createDisposal: mutation.mutateAsync,
    isLoading: mutation.isLoading
  }
}

export default useDisposal
